import { render } from "./LinkAnalyticsCorrectness.vue?vue&type=template&id=1c8978b8&scoped=true"
import script from "./LinkAnalyticsCorrectness.vue?vue&type=script&lang=js"
export * from "./LinkAnalyticsCorrectness.vue?vue&type=script&lang=js"

import "@/css/components/link-analytics-correctness.css?vue&type=style&index=0&id=1c8978b8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8978b8"]])

export default __exports__